import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Row, Col, Input, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import ModalLoteo from "../../Loteos/Modal";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import TableArchivos from '../../Loteos/TableArchivos';
import TableCuotas from './TableCuotas';
import TableCuotasEntrega from './TableCuotasEntrega';
import TableCuotasEspeciales from './TableCuotasEspeciales';
import api from "../../../api";
import apiFunctions from "../../../api/functions.js"
import { Monedas } from '../../Monedas/Monedas/constants.js'
import { format, formatCurrency } from '../../../functions/functions';
import { getMonedas } from "../../../api/apicalls.js";

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
            sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
}

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: moment(),
            vendedor_id: null,
            loteo_id: null,
            lote_id: null,
            compradores_id: [],
            estado: 'P',
            estadoInicial: 'P',
            comentarios: '',
            tipoVenta: 'C',
            tazaInteres: 0,
            seña: 0,
            cantidadCuotas: 0,
            entregaInicial: '0',
            tipoEntrega: 'C',
            cuotasEntrega: [],
            monedas: [], // Todas las Monedas de la api
            moneda: null, // Moneda para el Input (object)
            monto: '0',
            cuotasEspeciales: [],
            plantillas: [], // plantillas del lote con los campos de la venta reemplazada
            documentosEscritura: [],

            activeTab: 1,
            corrienteMes: false,
            mesInicioCuota: moment().add(1, 'months'),
            postVariables: [
                'vendedor_id',
                'loteo_id',
                'lote_id',
                'compradores_id',
                'estado',
                'comentarios',
                'tipoVenta',
                'tazaInteres',
                'seña',
                'cantidadCuotas',
                'entregaInicial',
                'tipoEntrega',
                'cuotasEntrega',
                'monto',
                'cuotasEspeciales',

                'corrienteMes'
            ],
            patchVariables: [
                'comentarios',
                'compradores_id',
                'tipoVenta',
                'tazaInteres',
                'seña',
                'cantidadCuotas',
                'entregaInicial',
                'tipoEntrega',
                'cuotasEntrega',
                'monto',
                'cuotasEspeciales',
                'corrienteMes'
            ],
            errors: {},
            calculos: {
                totalCuotas: 0,
                totalCuotasEspeciales: 0
            },
            compradores: [],

            caja_id: null,
            movimientoEgreso: false, //Check de devolucion al resindir
            monedaEgreso: null,
            montoEgreso: 0, //Monto a devolver
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE', 'FIRMAR', 'RESCINDIR', 'CUOTAS', 'RESERVAS']).isRequired,
    }

    async componentDidMount() {
        const monedas = await getMonedas();
        const monedaPesos = monedas
            ? monedas.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        this.setState({ 
            monedas,
            moneda: monedaPesos,
            monedaEgreso: monedaPesos,
        });
    }

    findMoneda = (monedaId) => {
        const { monedas } = this.state

        const moneda = monedas
            ? monedas.find(moneda => moneda.id === monedaId)
            : null;

        return moneda
    }

    getMonedaSimbolo = () => {
        const { moneda } = this.state
        return moneda ? moneda.simbolo : ""
    }

    componentDidUpdate(prevProps, prevState) {
        const { monto, entregaInicial, cantidadCuotas, cuotasEspeciales, tipoVenta, estado, seña } = this.state;
        const { action } = this.props;
        if (['F','E'].includes(tipoVenta) && (['CREATE', 'RESERVAS', 'DETAIL','RESCINDIR','EDIT', 'DELETE'].includes(action) || (action === 'FIRMAR' && estado === 'P')) &&
            (
                prevState.monto !== monto || prevState.entregaInicial !== entregaInicial ||
                    prevState.cantidadCuotas !== cantidadCuotas || prevState.cuotasEspeciales !== cuotasEspeciales ||
                    prevState.seña !== seña
            )){
            try{
                var montoValue = monto ? monto : 0;
                var señaValue = seña ? seña : 0;
                var entregaInicialValue = entregaInicial ? entregaInicial : 0;
                var cantidadCuotasValue =  cantidadCuotas ? cantidadCuotas : 0;
                var totalMontoCuotasEspecialesValue = 0;
                cuotasEspeciales.forEach( ce => totalMontoCuotasEspecialesValue = totalMontoCuotasEspecialesValue + (+ce.monto) );
                var totalCuotasValue = roundNumber((montoValue - entregaInicialValue - señaValue - totalMontoCuotasEspecialesValue) / cantidadCuotasValue,2);
                this.setState(prevState => {
                    let errors = prevState.errors;
                    errors['totalCuotas']= null;
                    errors['totalCuotasEspeciales']= null;
                    prevState.errors = errors;
                    prevState['calculos'] = {
                        totalCuotas: totalCuotasValue,
                        totalCuotasEspeciales: totalMontoCuotasEspecialesValue
                    };
                    return prevState;
                });
            }
            catch(err){
                console.log(err.message);
            }
        }
    }

    configuraciones = {};

    componentWillMount() {
        if (['CREATE'].includes(this.props.action)) {
            try {
                this.configuraciones = JSON.parse(localStorage.configuraciones);
                if (this.configuraciones) {
                    this.setState({
                        tazaInteres: this.configuraciones.tazaInteres_escritura
                    });
                }
            } catch(err) {
                // Sin configuracion
            }
        }
    }

    resetForm() {
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.setState({
            fecha: moment(),
            vendedor_id: null,
            loteo_id: null,
            lote_id: null,
            compradores_id: [],
            estado: 'P',
            estadoInicial: 'P',
            comentarios: '',
            tipoVenta: 'C',
            tazaInteres: this.configuraciones.tazaInteres_escritura ? this.configuraciones.tazaInteres_escritura : 0,
            seña: 0,
            cantidadCuotas: 0,
            entregaInicial: '0',
            tipoEntrega: 'C',
            cuotasEntrega: [],
            moneda: monedaPesos,
            monto: '0',
            cuotasEspeciales: [],
            plantillas: [],
            documentosEscritura: [],
            errors: {},
            activeTab: 1,
            calculos: {
                totalCuotas: 0,
                totalCuotasEspeciales: 0
            },
            compradores: [],
            corrienteMes: false,
            mesInicioCuota: moment().add(1, 'months'),

            caja_id: null,
            movimientoEgreso: false,
            monedaEgreso: monedaPesos,
            montoEgreso: 0,
        });
    }

    /*Ordena el array de cuotasEspeciales por la fecha asignada*/
    ordenarCuotasEspeciales = (cuotasEspeciales) =>{
        var x,y = 0;
        var momAux = moment();

        for (y=0;y<cuotasEspeciales.length; y++){
            //cuotasEspeciales[y]['vencimiento']=cuotasEspeciales[y]['fechayhora'].format('DD/MM/YYYY HH:mm');
            if (cuotasEspeciales.length>1){
                for (x=0;x < cuotasEspeciales.length-1;x++){

                    if (moment(cuotasEspeciales[x]['vencimiento']).isAfter(cuotasEspeciales[x+1]['vencimiento'])){

                        momAux=cuotasEspeciales[x];
                        cuotasEspeciales[x]=cuotasEspeciales[x+1];
                        cuotasEspeciales[x+1]=momAux;
                    }
                }
            }
        }
        return cuotasEspeciales;
    }

    getData() {
        const { action } = this.props;
        const {
            cuotasEspeciales,
            cuotasEntrega,
            caja_id,
            estado,
            movimientoEgreso,
            monedaEgreso,
            montoEgreso,
            mesInicioCuota,
            moneda,
        } = this.state;
        let cuotasOrdenadas = this.ordenarCuotasEspeciales(cuotasEspeciales);
        let cuotasEntregaOrdenadas = this.ordenarCuotasEspeciales(cuotasEntrega);

        const monedaId = moneda ? moneda.id : null;

        if (action === 'FIRMAR') {
            return {
                caja_id: caja_id,
                mesInicioCuota: mesInicioCuota.format('YYYY-MM-DD'),
                moneda: monedaId, 
            };
        } else if (action === 'RESCINDIR') {
            const { documentosEscritura } = this.state;

            let data = {
                documentos: documentosEscritura.map(p => p.id ? { id: p.id } : { archivo: p.archivo })
            };
            if (movimientoEgreso==true) {
                data.caja_id = caja_id;
                data.moneda_egreso = monedaEgreso ? monedaEgreso.id: null;
                data.montoEgreso = montoEgreso;
            }
            return data;
        } else if (action === 'EDIT') {
            const { patchVariables } = this.state;
            let data = {};
            patchVariables.forEach(x => {
                data[x] = this.state[x];
            });
            data.moneda = monedaId;

            // Especiales
            data.cantidadCuotasEspeciales = cuotasEspeciales.length;

            data.cuotasEspeciales = cuotasOrdenadas.map((ce, index) => ({
                nroCuota: index+1,
                vencimiento: moment(ce.vencimiento).format('YYYY-MM-DD'),
                id: ce.id,
                monto: ce.monto
            }));

            // Entrega
            data.cantidadCuotasEntrega = cuotasEntrega.length;

            data.cuotasEntrega = cuotasEntregaOrdenadas.map((ce, index) => ({
                nroCuota: index+1,
                vencimiento: moment(ce.vencimiento).format('YYYY-MM-DD'),
                id: ce.id,
                monto: ce.monto
            }));

            if (data.tipoEntrega === 'C'){
                data.cuotasEntrega = [];
            }


            if (data.tipoVenta === 'C') {
                data.entregaInicial = 0;
                data.cantidadCuotas = 0;
                data.cuotasEspeciales = [];
                data.cuotasEntrega = [];
                data.tipoEntrega = 'C';
            } else if (data.tipoVenta === 'F') {
                data.cuotasEspeciales = [];
            }
            data.documentos = this.state.documentosEscritura.map(p => p.id ? { id: p.id } : { archivo: p.archivo });

            return data;
        }

        // CREATE
        const { postVariables, fecha } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.fecha = fecha ? fecha.format('YYYY-MM-DD hh:mm:ss') : null;

        data.moneda = monedaId; 

        data.cuotasEspeciales = cuotasOrdenadas.map((ce, index) => ({ ...ce, vencimiento: moment(ce.vencimiento).format('YYYY-MM-DD'), nroCuota: index+1, }));
        data.cantidadCuotasEspeciales = cuotasEspeciales.length;

        data.cuotasEntrega = cuotasEntregaOrdenadas.map((ce, index) => ({ ...ce, vencimiento: moment(ce.vencimiento).format('YYYY-MM-DD'), nroCuota: index+1, }));
        data.cantidadCuotasEntraga = cuotasEntrega.length;

        data.documentos = this.state.documentosEscritura.map(p => p.id ? { id: p.id } : { archivo: p.archivo });

        if(action=='CREATE' && estado=='F'){
            data.caja_id = caja_id;
        }

        return data;
    }

    setData(data) {
        const { action } = this.props;
        if (data.success) {
            if ((action === 'CUOTAS') && (data.tipoVenta === 'C' || data.estado === 'P')) {
                return {
                    allowed: false,
                    message: data.estado === 'P' ? 'Debe firmar esta escritura para acceder a sus cuotas.' :'Esta escritura no posee cuotas.'
                };
            } else {
                if (action === 'DELETE' && data.estado === 'F') {
                    return {
                        allowed: false,
                        message: 'No puede eliminar una escritura firmado.'
                    }
                } else if (action === 'FIRMAR') {
                    if (data.estado === 'F') {
                        return {
                            allowed: false,
                            message: 'Esta escritura ya se encuentra firmado.'
                        }
                    } else if (data.estado === 'R') {
                        return {
                            allowed: false,
                            message: 'Esta escritura ya se encuentra rescindido.'
                        }
                    }
                } else if (action === 'RESCINDIR') {
                    if (data.estado === 'R') {
                        return {
                            allowed: false,
                            message: 'Esta escritura ya se encuentra rescindido.'
                        }
                    } else if (data.estado === 'P') {
                        return {
                            allowed: false,
                            message: 'No puede rescindir una escritura pendiente.'
                        }
                    }
                }

                let cuotasEspecialesAux = data.cuotas.filter(c => c.esEspecial).map(ce => ({ ...ce, vencimiento: moment(ce.vencimiento) }));
                cuotasEspecialesAux= this.ordenarCuotasEspeciales(cuotasEspecialesAux);

                let cuotasEntregaAux = data.cuotas.filter(c => c.esEntrega).map(ce => ({ ...ce, vencimiento: moment(ce.vencimiento) }));
                cuotasEntregaAux= this.ordenarCuotasEspeciales(cuotasEntregaAux);

                this.setState({
                    fecha: moment(data.fecha),
                    vendedor_id: data.vendedor_id,
                    loteo_id: data.loteo.id,
                    lote_id: data.lote.id,
                    compradores_id: data.compradores.map(comp => comp.id),
                    compradores: data.compradores,
                    estado: data.estado,
                    estadoInicial: data.estado,
                    comentarios: data.comentarios,
                    tipoVenta: data.tipoVenta,
                    tazaInteres: data.tazaInteres,
                    seña: data.seña,
                    cantidadCuotas: data.cantidadCuotas,
                    entregaInicial: data.entregaInicial,
                    tipoEntrega: data.tipoEntrega,
                    cuotasEntrega: cuotasEntregaAux,
                    moneda: data.moneda,
                    monto: data.monto,
                    cuotasEspeciales: cuotasEspecialesAux,
                    plantillas: data.loteo ? data.loteo.plantillas : [],
                    documentosEscritura: data.documentos,
                    cuotas: data.cuotas,
                    corrienteMes: data.corrienteMes,
                    monedaEgreso: data.moneda,
                });
            }
        }

    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
            else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Escritura",
                buttonTitle: "Nueva",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Escritura ha sido creada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "RESERVAS") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Escritura",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-usd fa-lg",
                successMessage: "La Escritura ha sido creada con éxito.",
                saveButton: true,
                buttonClass: "btn-success",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PATCH",
                title: "Editar Escritura",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Escritura ha sido editada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: this.state.estado == 'F',
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Escritura",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "CUOTAS") {
            return {
                get: true,
                submitType: null,
                title: "Escritura",
                buttonTitle: "Cuotas",
                danger: false,
                buttonIcon: "fa fa-money fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: (this.props.idV) ? (() => {return this.props.idV}) : (this.props.id),
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Escritura",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Escritura ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: 'Eliminar',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "FIRMAR") {
            return {
                get: true,
                modalClassName: 'modal-success',
                submitType: "PATCH",
                submitUrl: api.escrituras.firmar,
                title: "Firmar Escritura",
                buttonTitle: "Firmar",
                buttonIcon: "fa fa-check fa-lg",
                successMessage: "La Escritura ha sido firmada con éxito.",
                saveButton: this.state.estadoInicial === 'P',
                saveButtonLabel: 'Firmar',
                buttonClass: "btn-success",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "RESCINDIR") {
            return {
                get: true,
                modalClassName: 'modal-success',
                submitType: "PATCH",
                submitUrl: api.escrituras.rescindir,
                danger: true,
                title: "Rescindir Escritura",
                buttonTitle: "Rescindir",
                buttonIcon: "fa fa-ban fa-lg",
                successMessage: "La Escritura ha sido rescindida con éxito.",
                saveButton: true,
                saveButtonLabel: 'Rescindir',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onModalOpen = () => {
        const { activeTab, action } = this.props;
        if (activeTab) {
            this.setState({ activeTab });
        }
        // setea id del vendedor
        if (this.props.disabledReserva){

            let rowprop = this.props.row();

            this.setState({
                vendedor_id: (rowprop.vendedor) ? (rowprop.vendedor.id) : (null),
                loteo_id: (rowprop.loteo) ? (rowprop.loteo.id) : (null),
                lote_id: (rowprop.lote) ? (rowprop.lote.id) : (null),
                compradores_id: (rowprop.cliente) ? ([rowprop.cliente.id]) : ([]),
                compradores: (rowprop.cliente) ? ([rowprop.cliente]) : ([]),
                comentarios: (rowprop.comentarios) ? (rowprop.comentarios) : (null),
                seña: (rowprop.seña) ? (rowprop.seña) : (null),
                cantidadCuotas: (rowprop.cantidadCuotas) ? (rowprop.cantidadCuotas) : (null),
                tipoVenta: (rowprop.cantidadCuotas && rowprop.cantidadCuotas>0) ? ("F") : ("C"),
                monto: (rowprop.monto) ? (rowprop.monto) : (null),
            })

        }else if (action === 'CREATE') {
            const userId = localStorage.id;
            if (userId) {
                this.setState({
                    vendedor_id: userId,
                });
            }
        }

        if(action=='FIRMAR'){
            apiFunctions.get(api.caja.usuarioCaja, null, null, null, (response) => {
                if(response && response.data && response.data.caja_id){
                    this.setState({caja_id: response.data.caja_id});
                }
            });
        }
    }

    validateForm = () => {
        var that = this;
        var setErrors = function(field, code, detail){
            that.setState(
                prevState => {
                    prevState.errors[field] = [{
                        code: code.toString(),
                        detail: detail.toString()
                    }];
                    return prevState;
                })
        };

        const {
            fecha,
            vendedor_id,
            loteo_id,
            lote_id,
            compradores_id,
            estado,
            tipoVenta,
            seña,
            cantidadCuotas,
            entregaInicial,
            cuotasEspeciales,
            moneda,
            monto,
            caja_id,
            movimientoEgreso,
            monedaEgreso,
            montoEgreso,
            tipoEntrega,
            cuotasEntrega,
        } = this.state;
        const { totalCuotas, totalCuotasEspeciales } = this.state.calculos;
        const { action } = this.props;
        var cantidadErrores = 0;

        if (action == "RESCINDIR" && movimientoEgreso) {
            if (!monedaEgreso){
                setErrors('moneda_egreso', 'invalid', 'Moneda de egreso no especificada');
                cantidadErrores++;
            }

            if (caja_id == null) {
                setErrors('caja_id', 'invalid', 'Seleccione una caja');
                cantidadErrores++;
            }

            if (parseFloat(montoEgreso) == 0) {
                setErrors('montoEgreso', 'invalid', 'Ingrese el monto a devolver');
                cantidadErrores++;
            }
        }

        if (this.props.action!='RESCINDIR'){

            if (((action=="FIRMAR") || (action=="CREATE" && estado=="F")) && (caja_id == null)) {
                setErrors('caja_id', 'invalid', 'Seleccione una caja');
                cantidadErrores++;
            }

            if (vendedor_id === undefined || vendedor_id === null || vendedor_id <= 0) {
                setErrors('vendedor_id', 'invalid', 'Vendedor no especificado');
                cantidadErrores++;
            }
            if (loteo_id === undefined || loteo_id === null) {
                setErrors('loteo_id', 'invalid', 'Loteo no especificado');
                cantidadErrores++;
            }
            if (lote_id === undefined || lote_id === null) {
                setErrors('lote_id', 'invalid', 'Lote no especificado');
                cantidadErrores++;
            }
            if (compradores_id === undefined || compradores_id === null) {
                setErrors('compradores_id', 'invalid', 'Comprador no especificado');
                cantidadErrores++;
            }
            else{
                var errs = 0;
                compradores_id.forEach(
                    elem => {errs += (elem>0)?0:1;}
                );
                if(errs>0 || compradores_id.length == 0){
                    setErrors('compradores_id', 'invalid', 'Comprador no especificado');
                    cantidadErrores++;
                }
            }
            if (estado === undefined || (estado !== 'F' && estado !== 'P' && estado !== 'R')){
                setErrors('estado', 'invalid', 'Dato no valido');
                cantidadErrores++;
            }
            if (fecha === undefined || fecha === null || fecha.isValid() == false){
                setErrors('fecha', 'invalid', 'Fecha no valida');
                cantidadErrores++;
            }
            if (tipoVenta === undefined || (tipoVenta !== 'C' && tipoVenta !== 'F' && tipoVenta !== 'E')){
                setErrors('tipoVenta', 'invalid', 'Dato no valido');
                cantidadErrores++;
            }

            if (!moneda) {
                setErrors('moneda', 'invalid', 'Moneda no especificada');
                cantidadErrores++;
            }

            if (monto === undefined || (+monto<=0)){
                setErrors('monto', 'invalid', 'Monto no especificado');
                cantidadErrores++;
            }

            if (seña === undefined || (+seña<0)){
                setErrors('seña', 'invalid', 'Seña no especificado');
                cantidadErrores++;
            }else {
                if(monto !== undefined && (+seña)>(+monto)){
                    setErrors('seña', 'invalid', 'Seña superior a monto');
                    cantidadErrores++;
                }
            }
            if (cantidadCuotas === undefined || (+cantidadCuotas<0) || (tipoVenta !== 'C' && +cantidadCuotas <= 0)){
                if(tipoVenta !== 'E'){
                    setErrors('cantidadCuotas', 'invalid', 'Cantidad de Cuotas no especificado');
                    cantidadErrores++;
                }
            }

            const totalCuotasEntrega = (accumulator, currentValue) => accumulator + parseFloat(currentValue.monto);

            if (entregaInicial === undefined || cantidadCuotas === null || (+entregaInicial<0)|| (tipoVenta !== 'C' && +entregaInicial <= 0)){
                setErrors('entregaInicial', 'invalid', 'Entrega inicial no especificado');
                cantidadErrores++;
            }
            else if(tipoVenta !== 'C' && (+entregaInicial >= +monto)){
                setErrors('entregaInicial', 'invalid', 'Entrega inicial supera monto');
                cantidadErrores++;
            } else if(tipoEntrega=='F' && (+entregaInicial != cuotasEntrega.reduce(totalCuotasEntrega, 0))){
                setErrors('entregaInicial', 'invalid', 'La suma de las cuotas de entrega es distinta del monto');
                cantidadErrores++;
            }

            if (cuotasEspeciales === undefined || cuotasEspeciales === null || cuotasEspeciales.length > 0){
                var err = 0;
                cuotasEspeciales.forEach(
                    ce => {err += (ce.monto <= 0 || ce.vencimiento.isValid() == false)? 1 : 0;}
                );
                if(err > 0){
                    setErrors('cuotasEspeciales', 'invalid', 'Cuotas Especiales no validas');
                    cantidadErrores++;
                }
                else{
                    if(+totalCuotasEspeciales > +monto){
                        setErrors('cuotasEspeciales', 'invalid', 'Cuotas Especiales superan monto');
                        cantidadErrores++;
                    }
                }
            }
            if(cantidadErrores == 0 && (tipoVenta == 'F' || tipoVenta == 'E')){
                try{
                    var totalMontoCuotasEspecialesValue = 0;
                    cuotasEspeciales.forEach( ce => totalMontoCuotasEspecialesValue = totalMontoCuotasEspecialesValue + (+ce.monto));
                    var totalCuotasValue = roundNumber(((+monto) - (+entregaInicial) - (+seña) - (+totalMontoCuotasEspecialesValue)) / cantidadCuotas,2);
                    if (totalCuotasValue <= 0 || totalCuotasValue !== totalCuotas){
                        if(cantidadCuotas == undefined || cantidadCuotas == 0){
                            let totalSinCuotas =  ((+totalMontoCuotasEspecialesValue) + (+entregaInicial) + (+seña));
                            if(+totalSinCuotas<+monto){
                                setErrors('cuotasEspeciales', 'invalid', 'Falta $'+formatCurrency((+monto)-(+totalSinCuotas))+' para completar el monto');
                                cantidadErrores++;
                            }else if(+totalSinCuotas>+monto){
                                setErrors('cuotasEspeciales', 'invalid', 'Cuotas Especiales superan monto');
                                cantidadErrores++;
                            }

                        }else{
                            setErrors('totalCuotas', 'invalid', 'Valor de cuota no computable');
                            cantidadErrores++;
                        }
                    }
                }
                catch(err){
                    setErrors('totalCuotas', 'invalid', 'Valor de cuota no valido');
                    cantidadErrores++;
                }
            }
        }
        return cantidadErrores == 0;
    }

    setStateAndDeleteError(field, value){
        this.setState(prevState => { prevState.errors[field] = null;return prevState; });
        this.setState(prevState => { prevState[field] = value; return prevState });
    }

    onLoteoChange = (loteo) => {
        // Se setean tanto el loteo como su moneda preferida.
        // (Nota) La moneda tiene que poder cambiarse, la del loteo es solo
        // un default.
        const loteoId = loteo ? loteo.id : null;
        const monedaPreferida = loteo && loteo.moneda_preferida
            ? loteo.moneda_preferida
            : this.findMoneda(Monedas.PESOS);
        this.onChangeField('loteo_id', loteoId)
        this.onChangeField('lote_id', null)
        this.onChangeField('moneda', monedaPreferida)
    }

    onMonedaChange = (moneda) => {
        this.onChangeField('moneda', moneda)
        this.onChangeField('monedaEgreso', moneda)
    }

    onMonedaEgresoChange = (monedaEgreso) => {
        this.onChangeField('monedaEgreso', monedaEgreso)
    }

    AsignarDatosVentas = (venta) =>{
        if(venta!=null && venta.length>0){
            let data = venta[0];
            this.setState({
                vendedor_id: (data.vendedor!=null && data.vendedor!=undefined) ? (data.vendedor.id) : (null),
                compradores_id: (data.compradores) ? (data.compradores.map((e) => e.id)) : [],
            })
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        const { 
            estadoInicial,
            tipoVenta,
            activeTab,
            compradores,
            caja_id,
            moneda,
            monedaEgreso,
        } = this.state;
        const { totalCuotas, totalCuotasEspeciales } = this.state.calculos;

        const esEdit = action === 'EDIT' || action === 'CREATE';
        const estaPendiente = estadoInicial === 'P';
        const tieneCuotas = ['F', 'R'].includes(estadoInicial) && (action !== 'CREATE') && ['F', 'E'].includes(tipoVenta);

        return (
            <ParadigmaModal
                getUrl={(vars.get ? (vars.getUrl || api.escrituras.escrituras) : null)}
                submitUrl={(vars.submitType ? (vars.submitUrl || api.escrituras.escrituras) : null)}
                submitType={vars.submitType}
                id={vars.id}

                onOpen={this.onModalOpen}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}
                onValidation={() => (this.props.action != 'DELETE') ? (this.validateForm()) : (true)}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}

                className={'ui-paradigma-modal ui-sales-modal ui-sales-reservation-modal ui-modal-with-tabs ' + (activeTab === 2 ? 'modal-xl ' : 'modal-lg ') + vars.modalClassName}
                fileUploader
            >

                {
                    <Nav tabs className="ui-modal-tabs">
                        <NavItem>
                            <NavLink
                                className={(this.state.activeTab == 1 ? 'active' : '')}
                                onClick={() => { this.setState({ activeTab: 1 }) }}
                            >General</NavLink>
                        </NavItem>

                        {
                            tieneCuotas &&
                                <NavItem>
                                    <NavLink
                                        className={(this.state.activeTab == 2 ? 'active' : '')}
                                        onClick={() => { this.setState({ activeTab: 2 }) }}
                                    >Cuotas</NavLink>
                                </NavItem>
                        }

                        {
                            //!estaPendiente &&
                            <NavItem>
                                <NavLink
                                    className={(this.state.activeTab == 3 ? 'active' : '')}
                                    onClick={() => { this.setState({ activeTab: 3 }) }}
                                >Archivos</NavLink>
                            </NavItem>
                        }
                    </Nav>

                }

                <TabContent
                    activeTab={this.state.activeTab}
                    className={'ui-modal-tab-content pb-2' + (['CREATE'].includes(action) ? ' border-0' : '')}
                >

                    {/* GENERAL */}
                    <TabPane tabId={1} className="py-1 ui-sales-general-pane">
                        <Row>
                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Fecha"}
                                    error={() => this.getError('fecha')}
                                    inputComponent={
                                        <ParadigmaDatePicker
                                            disabled={vars.disabled}
                                            value={this.state.fecha}
                                            onChange={data => this.onChangeField('fecha', data)}
                                        />
                                    }
                                />
                            </Col>
                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Vendedor"}
                                    error={() => this.getError('vendedor_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            displayField="apellido_nombre"
                                            clearable={false}
                                            url={api.vendedores.usuarios}
                                            parameters={{
                                                paginationEnabled:false,
                                            }}
                                            disabled={vars.disabled}
                                            value={this.state.vendedor_id}
                                            onChange={data => this.onChangeField('vendedor_id', (data) ? data.id : null)}
                                        />
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-12 col-separator py-1">Datos de la escritura</Col>
                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Loteo"}
                                    error={() => this.getError('loteo_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            url={api.loteos.loteos_select}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['nombre']
                                            }}
                                            disabled={vars.disabled || this.props.disabledReserva}
                                            value={this.state.loteo_id}
                                            onChange={this.onLoteoChange}
                                            DetailComponent={this.state.loteo_id ? (props => <ModalLoteo {...props} action="DETAIL" activeTab={3} />) : null}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Lote"}
                                    error={() => this.getError('lote_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            optionRenderer={opts => `${opts.manzana} - ${opts.numero}`}
                                            url={this.state.loteo_id ? api.loteos.lotesSelect : ''}
                                            parameters={{
                                                id:this.state.loteo_id,
                                                paginationEnabled:false,
                                                sort:['manzana'],
                                                // concat: (action === 'CREATE' && this.state.loteo_id != undefined) ? (this.state.vendedor_id ? `vendido=False&vendedor_id=${this.state.vendedor_id}`+((!this.props.disabledReserva) ? ('&reservado=False') : ('')) : 'vendido=False'+((!this.props.disabledReserva) ? ('&reservado=False') : ('vendido=False'))) : 'vendido=False',
                                                concat: (action === 'CREATE' && this.state.loteo_id != undefined) ? 'vendido=True&servicio=True&escritura=False' : '',
                                            }}
                                            valueRenderer={opts => `Manzana: ${opts.manzana} - Número: ${opts.numero}`}
                                            disabled={vars.disabled || !this.state.loteo_id || this.props.disabledReserva}
                                            value={this.state.lote_id}
                                            onChange={data => {this.AsignarDatosVentas(data ? data.venta : null); this.onChangeField('lote_id', (data) ? data.id : null)}}
                                        />
                                    }
                                />
                            </Col>
                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Compradores"}
                                    error={() => this.getError('compradores_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            multiselect
                                            clearable={false}
                                            url={api.clientes.select}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['apellido']
                                            }}
                                            disabled={vars.disabled}
                                            displayField="nombre_completo"
                                            value={this.state.compradores_id ? this.state.compradores_id : []}
                                            onChange={data => {
                                                this.onChangeField('compradores_id', (data) ? data.map(comp => comp.id) : []);
                                                this.setState({ compradores: (data) ? data : [] })
                                            }}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Estado"}
                                    inputComponent={
                                        <div className="d-flex">
                                            <Button
                                                disabled={vars.disabled}
                                                className="mr-1 flex-grow-1"
                                                color={this.state.estado === 'P' ? 'warning' : 'secondary'}
                                                onClick={() => this.onChangeField('estado', 'P')}
                                            >
                                                Pendiente
                                            </Button>
                                            <Button
                                                disabled={vars.disabled}
                                                className="mr-1 flex-grow-1"
                                                color={this.state.estado === 'F' ? 'success' : 'secondary'}
                                                onClick={() => this.onChangeField('estado', 'F')}
                                            >
                                                Firmada
                                            </Button>
                                            {(action === 'DETAIL') || (action === 'EDIT') &&
                                                <Button
                                                    disabled={vars.disabled}
                                                    className="mr-1 flex-grow-1"
                                                    color={this.state.estado === 'R' ? 'danger' : 'secondary'}
                                                    onClick={() => this.onChangeField('estado', 'R')}
                                                >
                                                    Rescindida
                                                </Button>
                                            }
                                        </div>
                                    }
                                />
                            </Col>
                            <Col className="col-12">
                                <ParadigmaLabeledInput
                                    disabled={(esEdit) ? false : vars.disabled}
                                    md={[12, 12]}
                                    label={"Comentarios"}
                                    type="textarea"
                                    value={this.state.comentarios}
                                    onChange={e => this.onChangeField('comentarios', e.target.value)}
                                    error={() => this.getError('comentarios')}
                                />
                            </Col>

                            <Col xs={12} className="my-2">
                                {
                                    compradores.map(comprador => {
                                        let falta = [];
                                        if (comprador.direcciones_incompletos) falta.push('direcciones');
                                        if (comprador.emails_incompletos) falta.push('emails');
                                        if (comprador.telefonos_incompletos) falta.push('teléfonos');
                                        return (
                                            falta.length > 0 &&
                                                <div className="text-danger" key={comprador.id}>
                                                    <i className="fa fa-exclamation-circle mr-2"></i>
                                                    {`El cliente ${comprador.nombre_completo} no posee los siguientes datos: ${falta.join(', ')}.`}
                                                </div>
                                        );
                                    })
                                }
                            </Col>

                        </Row>

                        <Row className="ui-sales-contables-row">
                            <Col className="col-12 col-separator py-1">Contables</Col>

                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Moneda"}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            disabled={!esEdit}
                                            url={api.monedas.monedas}
                                            parameters={{
                                                paginationEnabled:false,
                                            }}
                                            value={moneda ? moneda.id : null}
                                            onChange={this.onMonedaChange}
                                        />
                                    }
                                    error={() => this.getError('moneda')}
                                />
                            </Col>

                            <Col className="col-12 col-lg-6 ui-layout-spacer"/>

                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Tipo"}
                                    error={() => this.getError('tipoVenta')}
                                    inputComponent={
                                        <Input
                                            disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                            type="select"
                                            value={this.state.tipoVenta}
                                            onChange={e => this.onChangeField('tipoVenta', e.target.value)}
                                        >
                                            <option value="C">Contado</option>
                                            <option value="F">Financiado</option>
                                            <option value="E">Especial</option>
                                        </Input>
                                    }
                                />
                            </Col>
                            {/* Solo mostrar el interes si se pagan cuotas, no hay vencimientos cuando se paga de
                                contado. */}
                            {this.state.tipoVenta != "C" &&
                                <Col className="col-12 col-lg-6">
                                    <ParadigmaLabeledInput
                                        md={[6, 6]}
                                        label={"Tasa Interes (Mensual)"}
                                        error={() => this.getError('tazaInteres')}
                                        inputComponent={
                                            <ParadigmaCurrencyInput
                                                disabled={!((action == "CREATE") || (action == "EDIT"))}
                                                className="form-control monto w-100"
                                                symbol={"%"}
                                                value={formatCurrency(this.state.tazaInteres)}
                                                onChange={data => this.onChangeField('tazaInteres', data)}
                                            />
                                        }
                                    />
                                </Col>
                            }

                            {this.state.tipoVenta === "C" &&
                                <Col className="col-12 col-lg-6 ui-layout-spacer"/>
                            }

                            {(action == "FIRMAR" && this.state.tipoVenta != "C") &&
                                <Fragment>
                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            md={[6, 6]}
                                            label={"Mes de la primera cuota"}
                                            inputComponent={
                                                <ParadigmaDatePicker
                                                    // disabled={vars.disabled}
                                                    value={this.state.mesInicioCuota}
                                                    monthpicker={true}
                                                    onChange={data => this.onChangeField('mesInicioCuota', data)}
                                                />
                                            }
                                            error={() => this.getError('mesInicioCuota')}
                                        />
                                    </Col>
                                    <Col className="col-12 col-lg-6 ui-layout-spacer"/>
                                </Fragment>}

                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Seña"}
                                    error={() => this.getError('seña')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                            className="form-control monto w-100"
                                            symbol={this.getMonedaSimbolo()}
                                            value={formatCurrency(this.state.seña >= 0 ? this.state.seña : Math.abs(this.state.seña))}
                                            onChange={data => this.setStateAndDeleteError('seña', data)}
                                        />
                                    }
                                />
                            </Col>

                            {(this.state.tipoVenta === 'F' || this.state.tipoVenta === 'E') &&
                                <Col className="col-12 col-lg-6 ui-layout-spacer"/>
                            }

                            {(this.state.tipoVenta === 'F' || this.state.tipoVenta === 'E') &&
                                <Fragment>
                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Tipo Entrega"}
                                            error={() => this.getError('tipoEntrega')}
                                            classNames={['pr-0','']}
                                            inputComponent={
                                                <Input
                                                    disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                                    type="select"
                                                    value={this.state.tipoEntrega}
                                                    onChange={e => this.onChangeField('tipoEntrega', e.target.value)}
                                                >
                                                    <option value="C">Contado</option>
                                                    <option value="F">Financiado</option>
                                                </Input>
                                            }
                                        />
                                    </Col>

                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Entrega"}
                                            error={() => this.getError('entregaInicial')}
                                            inputComponent={
                                                <ParadigmaCurrencyInput
                                                    disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                                    className="form-control monto w-100"
                                                    symbol={this.getMonedaSimbolo()}
                                                    value={formatCurrency(this.state.entregaInicial >= 0 ? this.state.entregaInicial : Math.abs(this.state.entregaInicial))}
                                                    onChange={data => this.setStateAndDeleteError('entregaInicial', data)}
                                                />
                                            }
                                        />
                                    </Col>

                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                            md={[3, 9]}
                                            label={"Cuotas"}
                                            type="number"
                                            value={this.state.cantidadCuotas}
                                            onChange={e => this.setStateAndDeleteError('cantidadCuotas', e.target.value)}
                                            error={() => this.getError('cantidadCuotas')}
                                            classNames={['', 'monto w-100']}
                                        />
                                    </Col>
                                </Fragment>}

                            <Col className="col-12 col-lg-6">
                                <ParadigmaLabeledInput
                                    md={[3, 9]}
                                    label={"Monto"}
                                    error={() => this.getError('monto')}
                                    inputComponent={
                                        <ParadigmaCurrencyInput
                                            disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                            className="form-control monto w-100"
                                            symbol={this.getMonedaSimbolo()}
                                            value={formatCurrency(this.state.monto >= 0 ? this.state.monto : Math.abs(this.state.monto))}
                                            onChange={data => this.setStateAndDeleteError('monto', data)}
                                        />
                                    }
                                />
                            </Col>

                            {this.state.tipoVenta === 'E' &&
                                <Col className={(this.state.tipoEntrega === 'F') ? 'col-6' : 'col-12'}>
                                    <Row>
                                        <Col className="col-12 col-separator mt-3 py-1">Cuotas especiales</Col>
                                        <Col className="col-12">
                                            <TableCuotasEspeciales
                                                disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                                cuotas={this.state.cuotasEspeciales}
                                                onChange={data => this.setState({ cuotasEspeciales: this.ordenarCuotasEspeciales(data.map(d => d)) })}
                                            />
                                        </Col>
                                    </Row>
                                </Col>}

                            {(this.state.tipoEntrega === 'F' && this.state.tipoVenta != 'C') &&
                                <Col className={(this.state.tipoVenta === 'E') ? 'col-6' : 'col-12'}>
                                    <Row>
                                        <Col className="col-12 col-separator mt-3 py-1">Cuotas entrega inicial</Col>
                                        <Col className="col-12">
                                            <TableCuotasEntrega
                                                disabled={esEdit ? !estaPendiente : (vars.disabled)}
                                                cuotas={this.state.cuotasEntrega}
                                                onChange={data => {
                                                    this.setState(prevState => { 
                                                        prevState.errors['entregaInicial'] = null;
                                                        return prevState;
                                                    });
                                                    this.setState({ cuotasEntrega: this.ordenarCuotasEspeciales(data.map(d => d)) })
                                                }}
                                                entregaInicial={this.state.entregaInicial}
                                            />
                                        </Col>
                                    </Row>
                                </Col>}

                        </Row>
                        {['F', 'E'].includes(tipoVenta) && (totalCuotas !== null || totalCuotasEspeciales !== null) && <hr />}
                        <Row>
                            {
                                ['F', 'E'].includes(tipoVenta) && totalCuotas !== null &&
                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            label="Valor de la cuota"
                                            md={[5, 7]}
                                            error = {()=>this.getError('totalCuotas')}
                                            inputComponent={
                                                <ParadigmaCurrencyInput
                                                    className="form-control monto w-100"
                                                    disabled={true}
                                                    symbol={this.getMonedaSimbolo()}
                                                    value={formatCurrency(totalCuotas)}
                                                    onChange={() => {}}
                                                />
                                            }
                                        />
                                    </Col>
                            }
                            {
                                tipoVenta === 'E' && totalCuotasEspeciales !== null &&
                                    <Col className="col-12 col-lg-6">
                                        <ParadigmaLabeledInput
                                            label="Monto especial"
                                            md={[5, 7]}
                                            error = {()=>this.getError('cuotasEspeciales')}
                                            inputComponent={
                                                <ParadigmaCurrencyInput
                                                    className="form-control monto w-100"
                                                    disabled={true}
                                                    symbol={this.getMonedaSimbolo()}
                                                    value={formatCurrency(totalCuotasEspeciales)}
                                                    onChange={() => {}}
                                                />
                                            }
                                        />
                                    </Col>
                            }
                        </Row>

                        {((action == "FIRMAR") || (action == "CREATE" && this.state.estado=='F')) &&
                            <Row className={'mt-3'}>
                                <Col className="col-12 col-lg-6">
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Caja"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={api.caja.caja}
                                                parameters={{
                                                    sort:['nombre'],
                                                    paginationEnabled:false,
                                                }}
                                                value={caja_id}
                                                onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                                            />
                                        }
                                        error={() => this.getError('caja_id')}
                                    />
                                </Col>
                            </Row>}

                        {(action == "RESCINDIR") &&
                            <Row className={'mt-3'}>
                                <Col className={"col-12  pl-0"}>
                                    <label className={"col-12"}>
                                        <input type="checkbox" /*disabled={vars.disabled || disableIfResolve}*/ className="filled-in" checked={this.state.movimientoEgreso} onChange={(e) => {}}/>
                                        <span onClick={() => {this.setState({movimientoEgreso: !this.state.movimientoEgreso})}}>Devolver Dinero</span>
                                    </label>
                                </Col>

                                {this.state.movimientoEgreso==true &&
                                    <Fragment>
                                        <Col className="col-12 col-lg-6">
                                            <ParadigmaLabeledInput
                                                md={[3, 9]}
                                                label={"Moneda"}
                                                inputComponent={
                                                    <ParadigmaAsyncSeeker
                                                        clearable={false}
                                                        url={api.monedas.monedas}
                                                        parameters={{
                                                            paginationEnabled:false,
                                                        }}
                                                        value={monedaEgreso ? monedaEgreso.id : null}
                                                        onChange={this.onMonedaEgresoChange}
                                                    />
                                                }
                                                error={() => this.getError('moneda_egreso')}
                                            />
                                        </Col>

                                        <Col className="col-12 col-lg-6">
                                            <ParadigmaLabeledInput
                                                md={[3, 9]}
                                                label={"Caja"}
                                                inputComponent={
                                                    <ParadigmaAsyncSeeker
                                                        clearable={false}
                                                        url={api.caja.caja}
                                                        parameters={{
                                                            sort:['nombre'],
                                                            paginationEnabled:false,
                                                        }}
                                                        value={this.state.caja_id}
                                                        onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                                                    />
                                                }
                                                error={() => this.getError('caja_id')}
                                            />
                                        </Col>

                                        <Col className="col-12 col-lg-6"/>

                                        <Col className="col-12 col-lg-6">
                                            <ParadigmaLabeledInput
                                                md={[3, 9]}
                                                label={"Monto"}
                                                error={() => this.getError('montoEgreso')}
                                                inputComponent={
                                                    <ParadigmaCurrencyInput
                                                        className="form-control monto w-100"
                                                        symbol={monedaEgreso ? monedaEgreso.simbolo : ''}
                                                        value={formatCurrency(this.state.montoEgreso)}
                                                        onChange={data => this.onChangeField('montoEgreso', data)}
                                                    />
                                                }
                                            />
                                        </Col>
                                    </Fragment>}

                            </Row>}

                    </TabPane>

                    {/* CUOTAS */}
                    {activeTab === 2 &&
                        <TabPane tabId={2} className="p-1">
                            {/*<TableCuotas id={this.props.id} disabled={this.state.estado === 'R'} />*/}
                            <TableCuotas id={vars.id} disabledCobro={(this.props.idV) ? (false) : (true)} disabled={this.state.estado === 'R'} />
                        </TabPane>
                    }

                    {
                        //action !== 'CREATE' && !estaPendiente &&
                        <TabPane tabId={3} className="py-1 ui-sales-files-pane">
                            <Row>
                                {//action !== 'CREATE' &&
                                    <Col className="col-12 col-lg-6">
                                        <Row>
                                            <Col className="col-12 col-separator mb-2 py-1">Plantillas de Escritura</Col>
                                            <Col className="col-12 mb-2 py-1">
                                                <TableArchivos
                                                    action="DETAIL"
                                                    archivos={this.state.plantillas}
                                                    //url={api.ventas.plantilla.replace('$id_venta', this.props.id())}
                                                    url={(vars.id) ? api.escrituras.plantilla.replace('$id_escritura', vars.id()) : null}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>}
                                <Col className="col-12 col-lg-6">
                                    <Row>
                                        <Col className="col-12 col-separator mb-2 py-1">Archivos de Escritura</Col>
                                        <Col className="col-12 mb-2 py-1">
                                            <TableArchivos
                                                action={action === 'RESCINDIR' ? 'EDIT' : action}
                                                archivos={this.state.documentosEscritura}
                                                onChange={documentosEscritura => this.onChangeField('documentosEscritura', documentosEscritura)}
                                                //url={api.ventas.documento.replace('$id_venta', this.props.id())}
                                                url={(vars.id) ? api.escrituras.documento.replace('$id_escritura', vars.id()) : null}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </TabPane>
                    }
                </TabContent>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Escrituras/Escrituras/Modal.js